import React from 'react'

import { IconTitleType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import { Image, Title, TitleSection } from './IconTitle.styled'

export const IconTitle = (props: IconTitleType): JSX.Element => {
    const { title, subTitle, iconTitleDescription, mode, items } = props

    return (
        <TitleSection title={title} subtitle={subTitle} description={iconTitleDescription} mode={mode}>
            <Grid container justifyContent="center">
                {items.map((item) => (
                    <Grid item xs={12} sm={4} md={3} lg={2} spacing={3} key={item.title} textAlign="center">
                        <Image image={item.icon} width={42} height={42} />
                        <Title>{item.title}</Title>
                    </Grid>
                ))}
            </Grid>
        </TitleSection>
    )
}
